// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2j7eB","select":"styles_select__2VKhq"};